// Shared typography sx fragments for the Market Analytics feature. These encode
// the repeated uppercase label + tabular metric patterns so the same scale is
// reused across the catalogue cards, detail panel, and enrichment card.

// Tiny uppercase label (stat tiles, column headers). 0.625rem.
export const microLabelSx = {
  fontSize: '0.625rem',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontWeight: 700,
  color: 'text.secondary',
} as const

// Section/group uppercase label (card sub-section headers). 0.6875rem.
export const sectionLabelSx = {
  fontSize: '0.6875rem',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  fontWeight: 700,
  color: 'text.secondary',
} as const

// Tabular metric value used across catalogue tables/rows. Per-usage `color` and
// `textAlign` overrides are spread on top where needed.
export const metricValueSx = {
  fontSize: '0.875rem',
  fontWeight: 700,
  fontVariantNumeric: 'tabular-nums',
} as const
